import React from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import { Link } from "react-router-dom";
import "./FinishScreen.css";

const FinishScreen = (props) => {
    const {
        title = "Congratulations!",
        subtitle = "You've completed the quiz",
        message = "Great job! You've successfully completed all the questions.",
        buttonText = "Back to Home",
        buttonLink = "/ChooseOption",
        score = null,
        totalQuestions = null,
        showStats = false,
        customContent = null,
        className = "",
        showFavorite = false,
        isFavorited = false,
        onFavorite = null,
        favoriteLoading = false
    } = props;

    return (
        <div className={`finish-screen skills ${className}`}>
            <div className="container">
                <Header type="primary" />
                <div className="content-wrap bg-gradient">
                    <div className="content-wrap-inner">
                        <div className="intro-box finish-box">
                            <div className="content">
                                <div className="finish-icon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="80"
                                        height="80"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        className="finish-check-icon"
                                    >
                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                    </svg>
                                </div>

                                <h2 className="finish-title">{title}</h2>
                                {subtitle && <h4 className="finish-subtitle">{subtitle}</h4>}

                                {showStats && score !== null && totalQuestions !== null && (
                                    <div className="finish-stats">
                                        <div className="stat-item">
                                            <div className="stat-number">{score}</div>
                                            <div className="stat-label">out of {totalQuestions}</div>
                                        </div>
                                        <div className="stat-item">
                                            <div className="stat-number">{Math.round((score / totalQuestions) * 100)}%</div>
                                            <div className="stat-label">Score</div>
                                        </div>
                                    </div>
                                )}

                                <p className="finish-message">{message}</p>

                                {customContent && (
                                    <div className="finish-custom-content">
                                        {customContent}
                                    </div>
                                )}

                                <div className="finish-buttons">
                                    {showFavorite && (
                                        <button
                                            className={`favorite-btn hover-bounce ${isFavorited ? 'active' : ''}`}
                                            onClick={onFavorite}
                                            disabled={favoriteLoading}
                                        >
                                            <span className={isFavorited ? "btn-favorite-selected" : "btn-favorite-unselected"}></span>
                                            {isFavorited ? 'Favorited' : 'Favorite'}
                                        </button>
                                    )}
                                    <Link to={buttonLink}>
                                        <button className="button-right-arrow hover-bounce button-white">
                                            {buttonText} <span className="arrow-right"></span>
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default FinishScreen;
